import React, { useEffect, useRef, useState } from "react";
import Utils from "Utils/utils";
import SearchInputBox from "Components/common/SearchInputBox";

export const CustomSingleDrodown = props => {
  const {
    options = [],
    sequenceId = "",
    parentIndex = "",
    loader = false,
    handleSequenceAction = () => {},
    handleScrollEnd = () => {},
    animationClass = "",
    search = false,
    filterFn = () => {},
    searchPlaceholder = "Search"
  } = props || {};
  console.log("CustomSingleDrodown");

  const [searchValue, setSearchValue] = useState("");
  const searchBoxRef = useRef(null);
  const dropdownRef = useRef(null);

  const changeAction = (event, item = {}) => {
    event && Utils.preventDefaultFn(event);
    handleSequenceAction(parentIndex, item);
  };

  const getAnimationClass = () => {
    return animationClass ? animationClass : "";
  };

  const defaultFilterFn = (opt, searchVal) =>
    (opt?.name || "").toLowerCase().includes(searchVal.toLowerCase());

  const filterFunc = filterFn || defaultFilterFn;

  const filteredOptions =
    searchValue && search
      ? options.filter(opt => filterFunc(opt, searchValue))
      : options;

  useEffect(() => {
    if (
      dropdownRef.current &&
      props.animationClass === "customDropDownFadeIn"
    ) {
      const listHeight =
        dropdownRef.current.querySelector(".dropdownList")?.offsetHeight || 0;
      dropdownRef.current.style.setProperty("--list-height", `${listHeight}px`);
    }
  }, [filteredOptions, props.animationClass]);

  return loader ? (
    <CustomDropdownLoader />
  ) : (
    <div
      className={`drop-down-menu animatedFast ${getAnimationClass()}`}
      ref={dropdownRef}
    >
      {search && (
        <SearchInputBox
          type="text"
          placeholder={searchPlaceholder}
          searchBoxRef={searchBoxRef}
          valueCbk={val => {
            setSearchValue(val);
          }}
        />
      )}
      <ul className="dropdownList" onScroll={event => handleScrollEnd(event)}>
        {filteredOptions?.length ? (
          filteredOptions?.map((item, index) => {
            const {
              id = "",
              name = "",
              email = "",
              key = "",
              shareType = "",
              accessType = "",
              owner = {},
              memberId = "",
              Icon = <></>,
              hasIcon = false,
              disabled = false
            } = item || {};
            return (
              <li
                key={`menu_${index}`}
                id={key}
                onClick={disabled ? () => {} : e => changeAction(e, item)}
                className={`option ${
                  sequenceId === id ? "sequenceSelected" : ""
                } ${disabled ? "disabled" : ""}`}
                title={name}
              >
                <div className="listItem">
                  <div className="listItemWrap">
                    {hasIcon && Icon && (
                      <span className="itemIcon">
                        <Icon />
                      </span>
                    )}
                    <span className="itemName">
                      {Utils.getEntityName(
                        shareType,
                        accessType,
                        owner,
                        name || email,
                        memberId
                      )}
                    </span>
                  </div>
                </div>
              </li>
            );
          })
        ) : (
          <span className="noSequencesMsg">No sequence found</span>
        )}
      </ul>
    </div>
  );
};

const CustomDropdownLoader = () => {
  return (
    <div className={`drop-down-menu`}>
      <ul className="dropdownList">
        {Array.from({ length: 10 }, (value, index) => (
          <li className="option optionLoader" key={`${index}`}>
            <div className="listItem linear-background" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomSingleDrodown;
